import { createFileRoute } from '@tanstack/react-router';
import { ResourceViewerPage } from '../../../../features/community-hub/components/resource-viewer-page';

/**
 * Community Hub - Resource Viewer Route
 * Path: /community-hub/resources/:id
 *
 * Full-page PDF viewer for resource content blocks
 */
export const Route = createFileRoute('/_protected/community-hub/resources/$id')({
  component: ResourceViewerPage,
});
